// The STAGING band across the top of every admin, scorekeeper and coach page off production (F1-251,
// F2-453; W8 #10). Renders nothing on production. See lib/environment.ts.
import { TriangleAlert } from 'lucide-react'
import { ENV_BAND, type EnvironmentBand as Band } from '@/lib/environment.ts'

export function EnvironmentBand({ band = ENV_BAND }: { band?: Band | null }) {
  if (!band) return null
  return (
    <div
      role="note"
      aria-label={band.text}
      data-environment={band.label}
      className="no-print flex items-center justify-center gap-2 border-b-4 border-ink bg-gold-bright px-4 py-1.5 text-center text-[13px] font-extrabold tracking-[0.08em] text-ink uppercase [background-image:repeating-linear-gradient(135deg,transparent_0_14px,rgba(9,28,24,0.08)_14px_28px)]"
    >
      <TriangleAlert className="size-4 shrink-0" aria-hidden />
      <span>{band.text}</span>
    </div>
  )
}
